import { AsyncPropSelector } from '@nile/components';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import { StatusHolder } from '@nile/projects/src/Components/Elements';
import { Button, ButtonGroup } from '@shopify/polaris';
import { Popover } from '@superops/ui-design-system';
import { Edit } from '@styled-icons/material/Edit';
import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { EditIcon } from '@nile/components/src/Icons';

const Field = styled.div`
  min-width: 200px;
  max-width: 250px;
  flex-grow: 1;
  padding-right: 10px;
  padding-left: 10px;
  margin-top: 8px;
  margin-bottom: 8px;
  .Polaris-ButtonGroup {
    margin-top: 12px;
  }
`;

const Wrap = styled.div`
  display: flex;
  align-items: center;
  .edit-actions {
    visibility: hidden;
    cursor: pointer;
  }
  &:hover {
    .edit-actions {
      visibility: visible;
    }
  }
  padding-right: 8px;
  max-width: 100%;
`;


const StatusCell = (props) => {
  const editable = props?.editable || false;
  const displayVal = props?.status || 'NA';
  const [popoverActive, setPopoverActive] = useState(false);
  const [currentVal, setCurrentVal] = useState(
    { label: props.status, value: props.status } || null
  );
  const togglePopoverActive = useCallback(() => {
    setPopoverActive(!popoverActive);
  });
  const activator = <EditIcon onClick={() => togglePopoverActive()} />;

  const onSaveAction = () => {
    props.handleUpdate(props.property, currentVal.value);
    togglePopoverActive();
  };

  const onCancelAction = () => {
    togglePopoverActive();
  };

  return !popoverActive ? (
    <Wrap className={`${editable ? 'editable-cell' : 'cell'}`}>
      <div className="ellipsis" title={displayVal}>
        {displayVal ? (
          <StatusHolder>{displayVal}</StatusHolder>
        ) : (
          <DisabledTag>NA</DisabledTag>
        )}
      </div>
      {editable && <div className="edit-actions">{activator}</div>}
    </Wrap>
  ) : (
    <Wrap className="editable-cell">
      <div className="ellipsis" title={displayVal}>
        {displayVal ? (
          <StatusHolder>{displayVal}</StatusHolder>
        ) : (
          <DisabledTag>NA</DisabledTag>
        )}
      </div>
      <Popover
        activator={activator}
        active={popoverActive}
        onClose={() => {
          return;
          //togglePopoverActive()
        }}
      >
        <Field>
          <AsyncPropSelector
            defaultValue={{ label: props.status, value: props.status }}
            updateSelection={(field, val) => setCurrentVal(val)}
            field={props.allEntityFields.find(
              (field) => field.name === props.property
            )}
            entity="Project"
          />
          <ButtonGroup className="mt10">
            <Button id="saveComboId" onClick={onCancelAction}>Cancel</Button>
            <Button primary onClick={onSaveAction}>
              Save
            </Button>
          </ButtonGroup>
        </Field>
      </Popover>
    </Wrap>
  );
};

export default StatusCell;
